import { GroupStatus } from "../../../lib/enum/group-status.mjs"
import { BadgeLabel } from "routes/regime/plugins/regime-title/badge-label"

export function GroupStatusBadge({ status, sx }) {
    const badgeColor = status && getGroupStatusBadgeColor(status)
    return (
        <BadgeLabel variant="subtitle2" sx={{ zoom: 0.8, ...sx }} color={badgeColor}>
            {status?.titleize()}
        </BadgeLabel>
    )
}

function getGroupStatusBadgeColor(status) {
    switch (status) {
        case GroupStatus.EDITING:
            return "authoringInProgress"
        case GroupStatus.APPLIED:
            return "authoringApplied"
        default:
            return ""
    }
}
